import { render, staticRenderFns } from "./AddReasonToNursing.vue?vue&type=template&id=0daa977e"
import script from "./AddReasonToNursing.vue?vue&type=script&lang=js"
export * from "./AddReasonToNursing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports